import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorQuoteSummaryCollapsed',
  props: {
    totalPrice: {}
  },
  emits: ["toggle-summary-modal"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const { isDesktop } = useIsDesktop(990);

  const emit = __emit;

  const toggleSummaryModal = () => {
    emit("toggle-summary-modal");
  };

const __returned__ = { props, isDesktop, emit, toggleSummaryModal, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})